// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tags__tag {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 10px;
  background-color: #f9f9f9;
  border-radius: 4px;
  margin-top: 5px;
}
.tags__empty-tags-error {
  min-height: 150px;
}
.tags__empty-tags-error .pui-loader-error__message {
  font-size: 16px;
  color: #adadad;
}
.tags .btn-action {
  color: #0078dc;
  padding: 0 5px 0 0;
}
.tags .btn-action:hover {
  color: #56a6fc;
}
.tags .btn-action--delete {
  color: #e6252e;
}
.tags .btn-action--delete:hover {
  color: #ef8085;
}
.tags .btn-action span {
  padding-left: 20px;
}
.tags .icon-edit {
  position: absolute;
  margin-top: 5px;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
